import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path
    d="M10.2221 1.88867H3.55545C2.94434 1.88867 2.44434 2.38867 2.44434 2.99978V10.7776H3.55545V2.99978H10.2221V1.88867ZM11.8888 4.11089H5.77767C5.16656 4.11089 4.66656 4.61089 4.66656 5.22201V12.9998C4.66656 13.6109 5.16656 14.1109 5.77767 14.1109H11.8888C12.4999 14.1109 12.9999 13.6109 12.9999 12.9998V5.22201C12.9999 4.61089 12.4999 4.11089 11.8888 4.11089ZM11.8888 12.9998H5.77767V5.22201H11.8888V12.9998Z"
    fill="#333333"
  />,
  'CopyText',
  16,
  '0 0 16 16'
)
